import { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { obtenerTitularLink } from '../../services/obtenerTitularLink';
import { Loading } from '../Common/Loading';
import CalendarioExterno from './CalendarioExterno';
import { Button, Heading, Text } from '@chakra-ui/react';
import { ReservarExterno } from './ReservarExterno';
import CalendarioContext from '../../context/calendarioContext';
import ConfirmacionExterno from './ConfirmacionExterno';
import { _bookingData } from './_bookingData';
import { diffDates } from '@fullcalendar/core/internal';
import { useTranslation } from 'react-i18next';

const Venta = () => {

  const { t } = useTranslation();

  const { codigo } = useParams();
  const { date, setDate, setDia, dia, rooms, setRooms } =
    useContext(CalendarioContext);
  const [user, setUser] = useState(null);
  const [error, setError] = useState({ error: false, msg: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [pasos, setPasos] = useState(1);
  const [selectedRoom, setSelectedRoom] = useState({});
  const [selectedOffer, setSelectedOffer] = useState({});
  const [bookingData, setBookingData] = useState(_bookingData);
  const [diff, setDiff] = useState({});
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (dia.start && dia.end) {
      setDiff(diffDates(dia.start, dia.end));
    }
  }, [dia]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const {
        data: { user, error },
      } = await obtenerTitularLink(codigo);

      if (error) {
        setError({ error: true, msg: 'Código de usuario no encontrado' });
      }

      if (user) {
        setUser(user);
      }

      setIsLoading(false);
    })();
  }, [codigo]);

  // antes tenia scroll, lo deshabilite
  /*  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref?.offsetTop,
      left: 0,
      behavior: 'smooth',
    });
  }; */

  useEffect(() => {
    if (pasos === 1) {
      setDia({});
      setRooms([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pasos]);

  if (!user && !isLoading)
    return (
      <div className="px-5 py-3">
        <Heading
          my="2"
          color="red.500"
        >
          {t('ERROR')}
        </Heading>
        <Text>{t('USER_CODE_NOT_FOUND')}</Text>
      </div>
    );

  if (isLoading) return <Loading />;

  return (
    <div style={{ height: '100vh' }}>
      {error.error && <span>Error: {error.msg}</span>}
      <CalendarioExterno
        user={user}
        enabled={pasos === 1}
        setPasos={setPasos}
        date={date}
        setDate={setDate}
        setDia={setDia}
      />
      <ReservarExterno
        user={user}
        enabled={pasos === 2 || pasos === 3}
        dia={dia}
        rooms={rooms}
        setRooms={setRooms}
        setPasos={setPasos}
        pasos={pasos}
        setSelectedOffer={setSelectedOffer}
        selectedRoom={selectedRoom}
        setSelectedRoom={setSelectedRoom}
        bookingData={bookingData}
        setBookingData={setBookingData}
      />
      <ConfirmacionExterno
        room={selectedRoom}
        date={dia}
        data={bookingData}
        id={user.id}
        noches={diff.days}
        offer={selectedOffer}
        enabled={pasos === 4}
        setBookingData={setBookingData}
        user={user}
        setDisabled={setDisabled}
      />
      <div className="d-flex justify-content-end">
        <Button
          pos={'fixed'}
          bottom={'0'}
          my="4"
          mx="3"
          colorScheme="orange"
          onClick={pasos > 1 ? () => setPasos(pasos - 1) : null}
          isDisabled={pasos < 2 || disabled}
        >
          {t('PREVIOUS_STEP')}
        </Button>
      </div>
    </div>
  );
};

export default Venta;
